import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ManualOrderService } from './manual-order/manual-order.service';



@Injectable({
  providedIn: 'root'
})


export class AuthGuard implements CanActivate {
  session_id: any;
  constructor(

    private webService: ManualOrderService,

    private router: Router
  ) { }
  async canActivate() {
    // let response =  await this.webService.getLoginSession();
    let data = localStorage.getItem('adminSession');

    if (data == 'true') {
      console.log(data)
      // this.router.navigate( ['/dashboard'] );
      return true

    } else {
      this.router.navigate(['/login']);
      return false
    }


  }




  encript(data) {
    return data.split("").reduce(function (a, b) {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
  }


}